import styled from 'styled-components';
import {
    blue,
    darkGreen,
    greyInputBorder,
    greyLight,
    greyText,
    greyLightBorder,
    lightGraishButton,
    lightGray,
    lightGreyButton,
    white,
} from '../../../../styles/Variables';
import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';

export const MobileFiltersWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 100%;
`;

export const Title = styled.h2`
    color: ${blue};
    font-size: 2.5rem;
    font-weight: 700;
    letter-spacing: 0.025em;
    line-height: 3rem;
    margin-top: 2rem;
    align-self: flex-start;
`;

export const FilterGroupWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    padding: 10px 0;

    span {
        font-weight: 700;
    }
`;

export const FilterSubtitle = styled.h3`
    text-transform: uppercase;
    font-size: 15pt;
    line-height: 1.25rem;
    font-weight: 700px;
    margin: 0;
    padding: 5px 0;
`;

export const FilterContentWrapper = styled.div`
    background-color: ${greyLight};
    padding: 20px;
    border-bottom: 1px solid ${greyLightBorder};

    :last-of-type {
        border: none;
    }
`;

export const Button = styled.button`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1rem;
    background: linear-gradient(${lightGreyButton}, ${lightGraishButton});
    color: ${darkGreen};
    border: 1px solid ${lightGray};
    min-width: 9.4em;
    padding: 0.75em 1.875em;
    border-radius: 5px;
    cursor: pointer;
    margin: 2rem 0;

    * {
        color: ${darkGreen};
    }
`;

export const UpIcon = styled(FaAngleDoubleUp)``;

export const DownIcon = styled(FaAngleDoubleDown)``;

export const SearchButton = styled(Button)`
    background: -webkit-linear-gradient(top, #94d232 0%, #8bba2b 100%);
    color: ${white};
`;

export const InputsGroupWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TextInputGroup = styled.div`
    display: flex;
    flex-direction: column;
    text-transform: capitalize;
    margin-bottom: 1rem;

    label {
        font-weight: 700;
        padding-bottom: 0.5rem;
    }

    input[type='text'] {
        padding: 12px 10px;
        border: 1px solid ${greyInputBorder};
        border-radius: 5px;
        color: ${greyText};
        outline: none;
        margin-bottom: 10px;
    }
`;
